import gql from 'graphql-tag'

export default gql`
mutation updateOfferGroups($fields: AppConfigAdditionalInput) {
	cashAssist {
		updateAppConfigAdditional(fields: $fields) {
			productActionGroups
		}
	}
}`
